let currentCsrfToken: string | null = null

export function getCsrfToken(): string | null {
  return currentCsrfToken
}

export function setCsrfToken(token: string | null): void {
  currentCsrfToken = token
}
